import React from "react";

const About = () => {
  return (
    <>
      <div className="row gx-0 mt-5 profile py-md-5" id="targetabout">
        <div className="col-md-9 m-auto">
          <div className="row gx-0 align-items-center">
            <div className="col-md-7">
              <h1 className="px-3 p-md-0">
                Hi, I'm a freelance full stack developer from Delhi, India
              </h1>
              <p
                className="mt-md-5 mb-md-2 px-3 p-md-0 text-muted"
                style={{ textAlign: "justify" }}
              >
                I am a Full Stack Developer. I specialize in Full Stack Web
                Development, including initial design analysis, as well as
                coding and content management. Enhancing my skills in a UI
                environment, incorporating all elements of the web including
                front-end development, Back-end development, usability research
                and user experience.
              </p>

              <p
                className="mb-5 px-3 p-md-0 text-muted"
                style={{ textAlign: "justify" }}
              >
                My favorite tools in 2022: <br />
                Programming Languages: JavaScript ES6. <br />
                Frontend: HTML 5, CSS 3, JavaScript ES6, Bootstrap 5, React JS{" "}
                <br />
                Backend: Node.js, Express. <br />
                Database: Mongo DB. <br />
                Version Control: GIT, GitHub. <br />
                Deployment: Netlify , Heroku.
              </p>
            </div>
            <div className="col-md-5 text-center">
              <img src="images/profile.png" className="img-fluid w-50" alt="" />
              <h5 className="my-3 py-0"> Vinay Singh </h5>
              <div className="mb-3 mb-md-0">
                <a
                  href="https://www.linkedin.com/in/vinayshilpani/"
                  rel="noreferrer"
                  target={"_blank"}
                >
                  <i class="ri-linkedin-box-line"></i>
                </a>
                <a
                  href="https://api.whatsapp.com/send?phone=918800811752"
                  rel="noreferrer"
                  target={"_blank"}
                >
                  <i class="ri-whatsapp-line"></i>
                </a>
                <a
                  href="https://www.instagram.com/whovinaysingh/"
                  target={"_blank"}
                  rel="noreferrer"
                >
                  <i class="ri-instagram-line"></i>
                </a>
                <a
                  href="https://www.messenger.com/t/100010867993454/"
                  target={"_blank"}
                  rel="noreferrer"
                >
                  <i class="ri-messenger-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
